import { AuthUserPermission } from '@cibo/core'
import { Can } from '@cibo/profile'
import Add from '@mui/icons-material/Add'
import Delete from '@mui/icons-material/Delete'
import Redo from '@mui/icons-material/Redo'
import { Box, Divider, Stack, Typography } from '@mui/material'
import { Outlet, generatePath, useNavigate, useParams } from 'react-router-dom'
import { CreateProgramEngagementButton } from '../../components/ProgramEngagementPlayer/CreateProgramEngagementButton'
import { DeleteApplicationButton } from '../../components/ProgramEngagementPlayer/DeleteApplicationButton'
import { EngagementInfo } from '../../components/ProgramEngagementPlayer/EnagementInfo'
import { ProgramMenu } from '../../components/ProgramEngagementPlayer/ProgramMenu'
import { UnconfirmStepButton } from '../../components/ProgramEngagementPlayer/UnconfirmStepButton'
import { Section } from '../../consts/Theme'
import { useProgramEngagementContext } from '../../features/ProgramEngagement'
import { GrowersRouteParams } from '../../navigation/types'
import { ENGAGEMENT_ROUTES, EngagementRouteParams } from '../../navigation/types/engagementRoutes'

export const ProgramLayout = () => {
  const { programId } = useParams<GrowersRouteParams>()
  const { engagementId, stageId, stepId } = useParams<EngagementRouteParams>()
  const { basePath, engagement, userId } = useProgramEngagementContext()
  const navigate = useNavigate()

  return (
    <Stack direction="row" spacing={3} alignItems={'flex-start'}>
      <Stack spacing={3} width={320}>
        <Section>
          <Box sx={{ maxWidth: '100%' }}>
            <ProgramMenu />
          </Box>
        </Section>
        {!!engagement.data?.id && <EngagementInfo engagementId={engagement.data?.id} />}

        <Can useAny={[AuthUserPermission.DEBUG_USER]}>
          <Divider />
          <Typography color="error" variant="overline">
            Debug
          </Typography>
          <Stack spacing={2}>
            {!!programId && !!userId && (
              <CreateProgramEngagementButton
                color="error"
                variant="outlined"
                onSuccess={({ id }) =>
                  navigate(
                    generatePath(`${basePath}${ENGAGEMENT_ROUTES.ENGAGEMENT}`, {
                      engagementId: id,
                    })
                  )
                }
                programId={programId}
                startIcon={<Add />}
                userId={userId}
              />
            )}

            <UnconfirmStepButton
              color="error"
              variant="outlined"
              engagementId={engagementId}
              startIcon={<Redo />}
              stepId={stepId}
              onSuccess={() =>
                navigate(
                  generatePath(`${basePath}${ENGAGEMENT_ROUTES.STEP}`, {
                    engagementId,
                    stageId,
                    stepId,
                  })
                )
              }
            />
            <DeleteApplicationButton
              color="error"
              variant="contained"
              engagementId={engagementId}
              onSuccess={() => navigate(basePath)}
              disabled={!engagementId}
              startIcon={<Delete />}
            />
          </Stack>
        </Can>
      </Stack>
      <Box flex={1}>
        <Outlet />
      </Box>
    </Stack>
  )
}
